
import React from 'react';
import logo from 'assets/images/amherst-logo.png';

const LogoAmherst = ({height}) => {
  return (
    <div style={{ marginRight: 8 }}>
      <img height={height} src={logo} alt="Amherst Logo" />
    </div>
  );
};

export default LogoAmherst;
